<template>
    <input class="border border-pink rounded-2xl py-3 px-4 bg-transparent text-pink placeholder-pink text-[18px]"
        type="email" :placeholder="placeholder" :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)">
</template>

<script>
export default {
    name: 'EmailInput',
    props: {
        placeholder: {
            type: String,
            default: 'Placeholder',
        },
        modelValue: {
            type: String,
            default: '',
        },
    }
}
</script>